import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Translate, translate } from 'react-jhipster';
import { NavLink as Link } from 'react-router-dom';
import { NavDropdown } from './menu-components';

export const EntitiesMenu = props => (
  // tslint:disable-next-line:jsx-self-close
  <NavDropdown icon="th-list" name={translate('global.menu.entities.main')} id="entity-menu">
    {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    <MenuItem icon="eye" to="/entity/user-detail">
      <Translate contentKey="global.menu.entities.viewInfo">Profile</Translate>
    </MenuItem>
    <MenuItem icon="pencil-alt" to="/entity/user-update">
      <Translate contentKey="global.menu.entities.updateInfo">Update</Translate>
    </MenuItem>
  </NavDropdown>
);
